import {Injectable} from '@angular/core';
import {tap} from "rxjs/operators";
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';
import {Observable} from 'rxjs';
import {LoginRequest, RefreshTokenRequest} from '@modules/authentication/interfaces/authentication.request';
import {LocalStorage} from '@core/storage/storage';
import {LOCAL_STORAGE} from '@core/constant/storage.constant';
import {Utils} from '@core/utils/utils';
import {BaseResponse} from '@core/models/base-response.model';
import {AuthenticationResponse} from '@modules/authentication/interfaces/authentication.response';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {
  readonly prefixUrl = UrlConstant.AUTHENTICATION.PREFIX;

  public login(param: LoginRequest): Observable<any> {
    const url = this.prefixUrl + UrlConstant.AUTHENTICATION.LOGIN;
    return this.post(url, param);
  }

  public logout() {
    // this.stopRefreshTokenTimer();
    const url = this.prefixUrl + UrlConstant.AUTHENTICATION.LOGOUT;
    return this.post(url, null);
  }

  public refreshToken(): Observable<any> {
    const refreshToken = LocalStorage.getItem(LOCAL_STORAGE.KEY.REFRESH_TOKEN);
    let body: RefreshTokenRequest = {refreshTokenId: null};
    body.refreshTokenId = refreshToken;
    const url = this.prefixUrl + UrlConstant.AUTHENTICATION.REFRESH_TOKEN;
    return this.post(url, body).pipe(
      tap(res => {
        LocalStorage.clear();
        this.saveStorage(res);
      })
    );
  }

  public isAuthenticated() {
    let accessToken = LocalStorage.getItem(LOCAL_STORAGE.KEY.ACCESS_TOKEN);
    let refreshToken = LocalStorage.getItem(LOCAL_STORAGE.KEY.REFRESH_TOKEN);
    // if (accessToken) {
    //   this.decodedRefreshToken = jwt_decode(refreshToken);
    //   return accessToken && (this.decodedRefreshToken.exp * 1000 - new Date().getTime() > 0);
    //   //return true;
    // }
    if (accessToken) return true;
  }

  public registerFcmToken(fcmToken: string): Observable<any> {
    return this.post(`${UrlConstant.USER.PREFIX}${UrlConstant.USER.REGISTER_FCM_TOKEN}?fcmToken=${encodeURIComponent(fcmToken)}`, null);
  }

  public saveStorage(res: BaseResponse<AuthenticationResponse, any>) {
    if (res && res.messageCode === MESSAGE_CODE.SUCCESS &&  !Utils.isUnKnownValue(res?.data?.accessToken)) {
      LocalStorage.setItem(LOCAL_STORAGE.KEY.USER, res.data.user);
      LocalStorage.setItem(LOCAL_STORAGE.KEY.ACCESS_TOKEN, res.data.accessToken);
      LocalStorage.setItem(LOCAL_STORAGE.KEY.REFRESH_TOKEN, res.data.refreshToken);
    }
  }

  /*private startRefreshTokenTimer() {
    let accessToken = StorageService.get(STORAGE_NAME.ACCESS_TOKEN);
    if (accessToken) {
      this.decodedAccessToken = jwt_decode(accessToken);
      const expires = new Date(this.decodedAccessToken.exp * 1000);
      const timeout = expires.getTime() - Date.now() - (30 * 1000);
      this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
    }
  }*/

  // private stopRefreshTokenTimer() {
  //   clearTimeout(this.refreshTokenTimeout);
  // }
}
